import * as React from 'react';

export type FacebookIconProps = React.HTMLAttributes<HTMLSpanElement> & {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  /** Defaults to your original SVG fill (#222222) */
  color?: string;
};

function FacebookIcon({
  size = 19,
  title = 'Facebook',
  className,
  style,
  color = '#222222',
  ...spanProps
}: FacebookIconProps) {
  const width = typeof size === 'number' ? `${Math.round((size * 9) / 19)}px` : size;
  const height = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width,
        height,
        lineHeight: 0,
        ...style,
      }}
      {...spanProps}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 9 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        aria-hidden
        focusable='false'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.87784 18.6875H2.11427V9.5H0.234375V6.33215H2.11427V4.43217C2.11427 1.84865 3.17501 0.3125 6.19115 0.3125H8.70523V3.48035H7.13487C5.96088 3.48035 5.88161 3.92502 5.88161 4.74823L5.87784 6.33215H8.7241L8.39191 9.5H5.88161V18.6875H5.87784Z'
          fill={color}
        />
      </svg>
    </span>
  );
}

export default FacebookIcon;
